import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {EtapeScenario, IEtapeScenario} from '../../_models/EtapeScenario';
import {
  Action,
  createAction,
  createReducer,
  props,
  on,
  createFeatureSelector,
  createSelector,
} from '@ngrx/store';

export const name = 'etapesScenario';

export interface EtapeScenarioState extends EntityState<IEtapeScenario> {
  selectedId: number | null;
  isInitialized: boolean;
  loading: boolean;
}

function selectEtapeScenario(a: IEtapeScenario): any {
  return a.id;
}

function sortByNom(a: IEtapeScenario, b: IEtapeScenario): number {
  if (a.nom < b.nom) {
    return -1;
  } else if (a.nom > b.nom) {
    return 1;
  } else {
    return 0;
  }
}

const adapter: EntityAdapter<IEtapeScenario> =
  createEntityAdapter<IEtapeScenario>({
    selectId: selectEtapeScenario,
    sortComparer: sortByNom,
  });

const initialState: EtapeScenarioState = adapter.getInitialState({
  selectedId: null,
  isInitialized: false,
  loading: true,
});

/* ACTION */
export const loadEtapeScenariosAction = createAction(
  '[EtapeScenario] Load EtapeScenarios',
  props<{ idSp: number }>()
);
export const loadEtapeScenariosSuccessAction = createAction(
  '[EtapeScenario] Load EtapeScenarios Success',
  props<{ payload: IEtapeScenario[] }>()
);
export const setEtapesScenariosSuccessAction = createAction(
  '[EtapeScenario] Set EtapeScenarios Success',
  props<{ payload: IEtapeScenario[] }>()
);

/* REDUCER */
const reducer = createReducer(
  initialState,
  on(loadEtapeScenariosSuccessAction, (state, {payload}) => {
    return adapter.setAll(payload, {
      ...state,
      isInitialized: true,
      loading: false,
    });
  }),
  on(setEtapesScenariosSuccessAction, (state, {payload}) => {
    return adapter.setAll(payload, state);
  }),
);

export function etapesScenarioReducer(
  state: EtapeScenarioState | undefined,
  action: Action
): EtapeScenarioState {
  return reducer(state, action);
}

/* SELECTOR */
const selectEtapeScenarioState =
  createFeatureSelector<EtapeScenarioState>(name);

export const {selectIds, selectEntities, selectAll, selectTotal} =
  adapter.getSelectors();
export const selectAllEtapeScenarios = createSelector(
  selectEtapeScenarioState,
  (state) => {
    return state.loading
      ? undefined
      : state.ids.map((id: any) => new EtapeScenario(state.entities[id]));
  }
);

const isInitialized = (state: EtapeScenarioState) => state.isInitialized;
export const selectIsEtapeScenarioInitialized = createSelector(
  selectEtapeScenarioState,
  isInitialized
);
